
import "./intro.css"

function ThisEvent () {
    return (
        <>
        <div >
        <p className="about">ABOUT ACMC</p>
        <p className="explanation"> 
             Ankara Condensed Matter Colloquia is a colloquium 
            series aimed at an audience of starting graduate 
            or advanced undergraduate students. Its primary aim is to provide a 
            pedagogical introduction to the cutting edge research areas in all fields 
            of both theoretical and experimental condensed matter physics research. 
            The first set of talks cover a wide range of subfields, including (but not limited to)
            many-body theory, quantum computation, topology and exotic magnetism. 

        </p>
        </div>
        </>

    )
}

export default ThisEvent